import React, { Component } from 'react'
import Details from './info'
// import Footer from './Foote'
import Welcome from './Welcome'

export default class Profile extends Component {
  render() {
    return (
      <div className='deta'>
        <Welcome />
        {/* <Details /> */}
      </div>
    )
  }
}
// import React, { Component } from 'react'

// export default class About extends Component {
//   render() {
//     return (
//         <div className='eye'>
//             <h1>About me</h1>
//             <span className='line'></span>
//             <div className='aboui'>

//             </div>
//         hello
//       </div>
//     )
//   }
// }